import { IDataForCurrencyIsAccepted } from '../../../actions/currency/requestForCurrency'
import { ICurrencyStore } from '../index'

export default function(
  state: ICurrencyStore,
  action: IDataForCurrencyIsAccepted,
): ICurrencyStore {
  return {
    ...state,
    currency: action.currency,
  }
}
